import { render } from "./FormPageToolbar.vue?vue&type=template&id=75594d46"
import script from "./FormPageToolbar.vue?vue&type=script&lang=js"
export * from "./FormPageToolbar.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"FormPageToolbar.vue"]])

export default __exports__